var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "notification-list" },
    _vm._l(_vm.notifications, function (notification, index) {
      return _c(
        "li",
        {
          key: notification._id || index,
          staticClass: "notification-list__item",
        },
        [
          _c("div", { staticClass: "d-flex align-items-start gap-3" }, [
            _vm._m(0, true),
            _c(
              "div",
              { staticClass: "notification-list__content" },
              [
                _c("h6", { staticClass: "notification-list__title" }, [
                  _vm._v(_vm._s(notification.nombre)),
                ]),
                notification.createdAt
                  ? _c(
                      "time",
                      {
                        staticClass: "notification-list__date",
                        attrs: { datetime: notification.createdAt },
                      },
                      [_vm._v(_vm._s(_vm.formatDate(notification.createdAt)))]
                    )
                  : _vm._e(),
                _c("p", { staticClass: "notification-list__text" }, [
                  _vm._v(_vm._s(notification.texto)),
                ]),
                notification.adjunto
                  ? _c(
                      "el-button",
                      {
                        staticClass: "p-0 mt-2 icono-accion",
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: "el-icon-download",
                          loading: _vm.downloadingId === notification._id,
                          disabled:
                            !!_vm.downloadingId &&
                            _vm.downloadingId !== notification._id,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("download", notification._id)
                          },
                        },
                      },
                      [_vm._v("Descargar adjunto")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "notification-list__icon",
        attrs: { "aria-hidden": "true" },
      },
      [_c("i", { staticClass: "el-icon-chat-dot-round" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }